import { Request } from '@types';

export type Notification = {
  notificationId: string;
  toUserId: string;
  fromUserId: string;
  entityId: string;
  type: NotificationType;
  read: boolean;
  text: string;
  createdAt: Date;
  updatedAt: Date;
  photoUrl?: string;
  request?: Request;
};

export type AddNotification = Pick<
  Notification,
  'toUserId' | 'fromUserId' | 'entityId' | 'type' | 'text' | 'photoUrl' | 'request'
>;

export enum NotificationType {
  COMMENT = 'COMMENT',
  FOLLOW = 'FOLLOW',
  FOLLOW_REQUEST = 'FOLLOW_REQUEST',
  GROUP_JOIN = 'GROUP_JOIN',
  GROUP_REQUEST = 'GROUP_REQUEST',
  LIKE = 'LIKE',
  MESSAGE = 'MESSAGE',
  PLAN = 'PLAN',
  PLAN_INVITE = 'PLAN_INVITE',
  PLAN_JOIN = 'PLAN_JOIN',
  PLAN_JOIN_REQUEST = 'PLAN_JOIN_REQUEST',
  PLAN_OVERLAP = 'PLAN_OVERLAP',
}
